import { useSelector } from 'react-redux';

export const LocationProvider = ({ render }) => {
  const location = useSelector((state) => state.location);
  return render(location);
};
